/** Hand-drawn cave tiles (docs/spec/04 §3). Rows are `|`-separated; see types.ts. */

import { frame } from './types';

export const SPACE = frame('........|........|........|........|........|........|........|........|'
  + '........|........|........|........|........|........|........|........');

export const DIRT = frame('1.11.11.|.11111.1|11.1.111|1111.11.|.1.111.1|111.1111|11.11.1.|.1111.11|'
  + '1.1.111.|111111.1|.11.1.11|11.1111.|1.11.1.1|.111.111|11.111.1|1.1.11.1');

export const BRICK = frame('2222.222|2222.222|1111.111|........|.2222222|.2222222|.1111111|........|'
  + '2222.222|2222.222|1111.111|........|.2222222|.2222222|.1111111|........');

export const STEEL = frame('3333333.|3322222.|3232232.|3222222.|3222222.|3222222.|3222222.|3222222.|'
  + '3222222.|3222222.|3222222.|3222222.|3222222.|3232232.|3222222.|........');

/** A cut gem: a flat table, a bright girdle near the top, the pavilion tapering to a point. */
export const GEM = frame('........|..3333..|.322223.|.322223.|32222223|33333333|32222223|.322223.|'
  + '.322223.|.321123.|..3113..|..3113..|..3113..|...33...|...33...|........');

export const BOULDER = frame('........|..2222..|.232222.|.3322222|23322222|23222222|22222221|22222221|'
  + '22222221|22222211|22222211|.222211.|.222111.|..2111..|........|........');

/** The inbox and the open exit alternate this with the steel face to flash. */
export const DOOR = frame('3333333.|3222222.|32....2.|32....2.|32....2.|32....2.|32....2.|32..3.2.|'
  + '32..3.2.|32....2.|32....2.|32....2.|32....2.|32....2.|3222222.|........');

/** Keys and doors: drawn in their own colours (palette.ts KEY_COLOURS). */
export const KEY = frame('........|..222...|.23.22..|.2...2..|.2...2..|..222...|...2....|...2....|'
  + '...22...|...2....|...222..|...2....|...22...|........|........|........');

export const LOCKED_DOOR = frame('3333333.|3222222.|3211112.|3212212.|3212212.|3211112.|3222222.|322..22.|'
  + '322..22.|322..22.|3222222.|3211112.|3212212.|3211112.|3222222.|........');

export const OPEN_DOOR = frame('3333333.|3......2|3......2|3......2|3......2|3......2|3......2|3......2|'
  + '3......2|3......2|3......2|3......2|3......2|3......2|3222222.|........');

export const CLOCK_A = frame('........|.222222.|.2....2.|..2333..|..2333..|...23...|...23...|...22...|'
  + '...2....|..2.....|..2...2.|.2.....2|.2..3..2|.222222.|........|........');

export const CLOCK_B = frame('........|.222222.|.2....2.|..2....2|..2...2.|...2.2..|...23...|...23...|'
  + '...23...|..2.3...|..2.3.2.|.2.333.2|.2.3332.|.222222.|........|........');
